import React, { useEffect, useRef, useState } from 'react';

import { useViewType, ViewType } from '@eika/hooks';

export const MOBILE_ONLY_CLASS = 'sgw-layout-item__mobile-only';
export const NOT_MOBILE_ONLY_CLASS = 'sgw-layout-item__not-mobile';

const getParentView = (element: HTMLElement | null): ViewType | null => {
    if (element === null || element.tagName === 'body') {
        return null;
    }
    if (element.closest(`.${MOBILE_ONLY_CLASS}`) !== null) {
        return ViewType.mobile;
    }
    if (element.closest(`.${NOT_MOBILE_ONLY_CLASS}`) !== null) {
        return ViewType.desktop;
    }
    return null;
};

interface Props extends React.PropsWithChildren {
    globalCssNamespace: string;
}

const AutoHideWidget: React.FC<Props> = ({ children, globalCssNamespace }) => {
    const htmlRef = useRef<HTMLDivElement>(null);
    const [parentViewType, setParentViewType] = useState<ViewType | null>(null);
    const viewType = useViewType();

    useEffect(() => {
        if (htmlRef.current) {
            setParentViewType(getParentView(htmlRef.current));
        }
    }, [htmlRef]);

    if (
        (parentViewType === ViewType.desktop && viewType !== ViewType.desktop) ||
        (parentViewType === ViewType.mobile && viewType === ViewType.desktop)
    ) {
        return null;
    }

    return (
        <div className={globalCssNamespace} ref={htmlRef}>
            {children}
        </div>
    );
};

export default AutoHideWidget;
